import Switch from "@mui/material/Switch";

const THUMB = 22;
const TRACK_H = 22;
const ROOT_W = 52;
const ROOT_H = 30;
const H_PAD = 5;
/** Horizontal travel so thumb sits symmetrically inside the track */
const TRAVEL_X = ROOT_W - THUMB - 2 * H_PAD;

const sx = {
  width: ROOT_W,
  height: ROOT_H,
  padding: 0,
  overflow: "visible",
  position: "relative",
  boxSizing: "border-box",
  /* Track centered in root — removes top/bottom purple “gap” vs thumb */
  "& .MuiSwitch-track": {
    position: "absolute",
    top: "50%",
    left: 0,
    right: 0,
    margin: 0,
    height: TRACK_H,
    transform: "translateY(-50%)",
    borderRadius: TRACK_H / 2,
    opacity: 1,
    backgroundColor: "rgba(136, 136, 136, 0.35)",
    border: "1px solid rgba(0, 0, 0, 0.06)",
    transition: "background-color 200ms, box-shadow 200ms",
    boxSizing: "border-box",
  },
  /* Thumb vertically centered; same center line as track */
  "& .MuiSwitch-switchBase": {
    position: "absolute",
    top: "50%",
    left: H_PAD,
    padding: 0,
    margin: 0,
    transform: "translateY(-50%)",
    transitionDuration: "200ms",
    "&.Mui-checked": {
      transform: `translate(${TRAVEL_X}px, -50%)`,
      color: "#fff",
      "& + .MuiSwitch-track": {
        background: "linear-gradient(135deg, var(--purple) 0%, #6b2fd4 100%)",
        opacity: 1,
        boxShadow: "inset 0 1px 2px rgba(255,255,255,0.25)",
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.4,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "var(--purple)",
      border: "6px solid #fff",
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: THUMB,
    height: THUMB,
    background: "linear-gradient(180deg, #ffffff 0%, #f0f0f0 100%)",
    boxShadow: "0 2px 6px rgba(0,0,0,0.22), 0 1px 2px rgba(0,0,0,0.12)",
  },
};

/**
 * Parent should set checked + onChange.
 */
export default function ThemeSwitch(props) {
  const { sx: sxProp, className, ...rest } = props;
  return (
    <Switch
      className={className ? `theme-switch ${className}` : "theme-switch"}
      disableRipple
      inputProps={{ "aria-label": "Toggle dark or light theme" }}
      {...rest}
      sx={sxProp ? { ...sx, ...sxProp } : sx}
    />
  );
}
